import type { clientList, transferPending } from './type'
import transferData from '../../data/transferData.json'
import pendingTransfersData from '../../data/pendingTransfersData.json'

export class transferService {
  async transferAccountList(
    clientId: number,
  ): Promise<{ beneficiaryList: clientList[]; myAccountList: clientList[] }> {
    const beneficiaryList = transferData.data.filter(
      (transfer: { clientId: number; isBeneficiary: boolean }) =>
        transfer.clientId === clientId && transfer.isBeneficiary === true,
    )

    const myAccountList = transferData.data.filter(
      (transfer: { clientId: number; isBeneficiary: boolean }) =>
        transfer.clientId === clientId && transfer.isBeneficiary === false,
    )

    return { beneficiaryList, myAccountList }
  }

  async getTransferById(
    clientId: number,
    transferStatus: number,
    page: number = 0,
    size: number = 10,
  ): Promise<{ data: transferPending[]; total: number }> {

    if (!clientId || transferStatus === undefined || transferStatus === null) {
      throw new Error('Both clientId and transferStatus are required.')
    }

    const allTransfers = pendingTransfersData.data
      .filter((transfer) => transfer.clientId === clientId && transfer.status.id === transferStatus)

    const total = allTransfers.length
    const start = page * size
    const end = start + size
    const paginatedData = allTransfers.slice(start, end)

    return {
      data: paginatedData,
      total,
    }
  }
}
